/**
 * Важное
 */
require('popper.js/dist/popper.min');
require('./dependencies/dependencies');
//require('../../modules/vegas/js/util/proto/_manipulation');
require('../../modules/index.esm')
/**
 * Сам проект
 */
window.boot = require('./project/esm');
require('./project/index');

/**
 * Модули проекта
 */
require('./project/src/modules/analytics/analytics');
require('./project/src/modules/social');
require('./project/src/modules/video');
require('./project/src/modules/map');
require('./project/src/modules/jivo');
require('./project/src/modules/interactive-maps/interactive-maps');

// Анимация прокрутки
//window.AOS = require('aos/dist/aos');
